import styled from 'styled-components';

export const Container = styled.div`
  height: 100%;
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: center;
`;

export const IconButton = styled.button`
  height: 90%;
  width: 60%;
  border-radius: 6px;

  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ItemSelect = styled.button`
  width: 100%;
  height: 35px;

  display: flex;
  align-items: center;

  border-radius: 4px;

  &:hover {
    background-color: ${({ theme }) => `${theme.colors.primary}20`};
  }

  .check-container {
    flex: 0.2;
    display: flex;
    justify-content: center;

    svg {
      fill: ${({ theme }) => theme.colors.primary};
    }
  }

  p {
    flex: 1;
    font-size: 1rem;
    text-align: left;
  }
`;
